import React from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { GridContainer, Modal, GridRow, FormElements, Grid, Spinner } from '@custom-components';
import * as yup from 'yup';

function CreateConnectorsModal(props) {
  const { closeModal, createConnector, connectionTypes } = props;
  const loading = false;

  const getHydratedConnection = (name) => {
    if (name) {
      // Replace all occurrences using regex and split it into array of words
      const words = name.replace(/_/g, ' ').split(' ');

      words.forEach(([first, ...restWords], i) => {
        words[i] = first.toUpperCase() + restWords.join('').toLowerCase();
      });

      return words.join(' ');
    }
    return name;
  };

  const connectionTypeOptions = connectionTypes.map((typeOption) => {
    const { id, connectionType } = typeOption;

    return {
      label: getHydratedConnection(connectionType),
      value: id
    };
  });

  const handleOnSubmit = async (values) => {
    const { name, url, connectionType } = values;

    const connectorInput = {
      name,
      url,
      connectionTypeId: parseInt(connectionType, 10)
      // identityId: parseInt(admin.userId, 10)
    };
    await createConnector(connectorInput);
    closeModal();
  };

  const validationSchema = () =>
    yup.object().shape({
      name: yup
        .string()
        .trim()
        .min(1, 'Must be at least one character')
        .max(50, 'Must be shorter than 50 characters')
        .matches(/^[a-z0-9_.,-\s\\(\\)]+$/i, 'No special characters')
        .required('You must provide a name'),
      url: yup.string().url('Enter a valid URL address').trim().nullable().max(150, 'Max 150 characters allowed'),
      connectionType: yup.string().trim().required('You must select a connection type')
    });

  return (
    <Formik
      initialValues={{
        name: '',
        url: '',
        connectionType: ''
      }}
      onSubmit={handleOnSubmit}
      validationSchema={validationSchema()}
    >
      {({ values, errors, setFieldValue, handleSubmit, submitCount, isSubmitting }) => (
        <Modal
          openModal
          title={<strong>CREATE NEW CONNECTOR</strong>}
          actions={[
            {
              label: 'Cancel',
              onClick: () => {
                closeModal();
              },
              btnTheme: 'secondary'
            },
            {
              label: 'Save',
              onClick: handleSubmit,
              btnTheme: 'primary',
              loading: isSubmitting,
              disabled: isSubmitting
            }
          ]}
          handleClose={() => {
            closeModal();
          }}
        >
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <Spinner thickness={4} size={50} />
            </div>
          ) : (
            <GridContainer style={{ width: '500px' }}>
              <GridRow>
                <Grid.Col lg={12}>
                  <FormElements.TextInput
                    name="connectorName"
                    id="connectorName"
                    label="Name"
                    error={submitCount > 0 && !!errors.name}
                    errorText={errors.name}
                    value={values.name}
                    onChange={(e) => setFieldValue('name', e.target.value)}
                  />
                </Grid.Col>
              </GridRow>
              <GridRow>
                <Grid.Col lg={12}>
                  <FormElements.TextInput
                    name="connectorUrl"
                    id="connectorUrl"
                    label="URL"
                    error={submitCount > 0 && !!errors.url}
                    errorText={errors.url}
                    value={values.url}
                    onChange={(e) => setFieldValue('url', e.target.value)}
                  />
                </Grid.Col>
              </GridRow>
              <GridRow>
                <Grid.Col lg={12}>
                  <FormElements.Select
                    label="Connection Type"
                    name="connectionType"
                    key="connectionType"
                    id="connectionType"
                    value={values.connectionType}
                    options={connectionTypeOptions}
                    onChange={(item) => {
                      if (item) {
                        const option = {
                          target: {
                            value: item.target.value,
                            label:
                              connectionTypeOptions[
                                connectionTypeOptions.findIndex((e) => e.value === item.target.value)
                              ].label
                          }
                        };
                        setFieldValue('connectionType', option.target.value);
                      }
                    }}
                    inputProps={{ readOnly: true }}
                    required
                  />
                </Grid.Col>
              </GridRow>
            </GridContainer>
          )}
        </Modal>
      )}
    </Formik>
  );
}

const connectionTypePropType = PropTypes.shape({
  id: PropTypes.number,
  connectionType: PropTypes.string
});

CreateConnectorsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  createConnector: PropTypes.func.isRequired,
  admin: PropTypes.shape({}).isRequired,
  connectionTypes: PropTypes.arrayOf(connectionTypePropType).isRequired
};

export default CreateConnectorsModal;
